<template>
  <Teleport to="body">
  <div
    v-if="props.visible"
    class="modal fade show"
    id="exampleModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-modal="true"
    style="display: block; background-color: rgba(0, 0, 0, 0.3); z-index: 11000"
    @click.stop="onBackClick"
  >
    <div
      class="popup-dialog modal-dialog modal-dialog-centered modal-sm"
      @click.stop="() => {}"
    >
      <div class="modal-content popup-content">
        <div class="popup-inner">
          <div class="popup-header">
            <h5 class="popup-title">
              {{ props.title }}
            </h5>
            <button
              type="button"
              class="popup-close-btn"
              aria-label="Close"
              @click.stop="onCloseClick"
            >
              <i class="fa-solid fa-x"></i>
            </button>
          </div>

          <div class="popup-body">
            <slot></slot>
          </div>

          <div class="popup-footer">
            <button
              v-if="props.showCancel"
              type="button"
              class="popup-btn popup-btn-cancel"
              @click.stop="onCancelClick"
            >
              {{ props.cancelText }}
            </button>
            <button type="button" class="popup-btn popup-btn-primary" @click.stop="onOkClick">
              {{ props.okText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  </Teleport>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: '알림',
  },
  okText: {
    type: String,
    default: '확인',
  },
  cancelText: {
    type: String,
    default: '취소',
  },
  okCallback: {
    type: Function,
  },
  closeCallback: {
    type: Function,
  },
  cancelCallback: {
    type: Function,
  },
  showCancel: {
    type: Boolean,
    default: true,
  },
  clickable: {
    type: Boolean,
    default: true,
  },
});

const onOkClick = () => {
  if (props.okCallback) {
    props.okCallback();
  }
};

const onCancelClick = () => {
  if (props.cancelCallback) {
    props.cancelCallback();
  }
};

const onCloseClick = () => {
  if (props.closeCallback) {
    props.closeCallback();
  } else if (props.cancelCallback) {
    props.cancelCallback();
  }
  //    else if (props.okCallback) {
  //     props.okCallback();
  //   }
};

const onBackClick = () => {
  if (props.clickable) {
    onCloseClick();
  }
};
</script>

<style scoped>
.popup-dialog {
  margin-left: auto;
  margin-right: auto;
  width: calc(100% - 2rem);
  max-width: var(--bs-modal-width);
}

.popup-content {
  border-radius: 1.2rem;
  overflow: hidden;
  padding: 0;
}

.popup-inner {
  padding: 1.5rem;
}

.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.25rem;
}

.popup-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #212529;
  margin: 0;
}

.popup-close-btn {
  background: none;
  border: none;
  padding: 0.5rem;
  cursor: pointer;
  color: #6c757d;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 0.5rem;
  transition: all 0.2s ease;
}

.popup-close-btn:hover {
  background-color: #f8f9fa;
  color: #212529;
}

.popup-body {
  margin-bottom: 1.5rem;
}

.popup-footer {
  display: flex;
  gap: 0.75rem;
}

.popup-btn {
  flex: 1;
  padding: 0.75rem 1rem;
  border: none;
  border-radius: 0.75rem;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.popup-btn-cancel {
  background-color: #ffffff;
  color: #6c757d;
  border: 1px solid #dee2e6;
}

.popup-btn-cancel:hover {
  background-color: #f8f9fa;
  border-color: #adb5bd;
}

.popup-btn-primary {
  background-color: #0d6efd;
  color: #ffffff;
}

.popup-btn-primary:hover {
  background-color: #0b5ed7;
}
</style>
